import * as ActionTypes from '../ActionTypes'
import * as RestURI from '../../shared/RestURI';

import {awsConfig} from '../../shared/config';
import {addToBucket, setBucket} from './ActionCreatorsBucket';
import * as AuthC from '../../utils/auth/AuthCognito';
import {getAuthorizedWorksitesForContextClient} from '../../utils/auth/Security';




export const fetchRsvtiTasks = (clientId) => (dispatch) => {
    if(!clientId)
        return;

    dispatch(tasksLoading({clientId: clientId}));

    const urlParams = new URLSearchParams({ clientId: clientId});
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.TASKS}?${urlParams}`);

    // we overfetch and filter by authorized Worksites afterwards
    const authzWorksites = getAuthorizedWorksitesForContextClient();

    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json())
        .then(tasks => {
            if(!authzWorksites) {
                return dispatch(addTasks(tasks))
            }
            else {
                const filteredTasks = tasks.filter(task => (
                                                        task.details.activeStep === 0 || 
                                                        task.details.activeStep === 1 || 
                                                        (task.details.activeStep > 1 && authzWorksites.includes( task.step1.worksiteId ))
                                        ))

                return dispatch(addTasks(filteredTasks))
            }
        })
        .catch(error => dispatch(tasksFailed(error.message)));
}


export const postRsvtiTask = (task) => (dispatch) => {
    task.createDate = new Date().toISOString();
  
    const bearer = 'Bearer ' + AuthC.getJwtToken();

    return fetch(awsConfig.api.invokeUrl + RestURI.TASKS, {
        method: "POST",
        body: JSON.stringify(task),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
    .then(response => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error('Error ' + response.status + ': ' + response.statusText);
          error.response = response;
          throw error;
        }
      },
      error => {
        throw error;
      }
    )
    .then(response => response.json())
    .then(ddbTask => dispatch(addTask(ddbTask)))
    .then(taskAction => dispatch(setBucket({ mostRecentTaskId: taskAction.payload.id })))
    .catch(error =>  {
        dispatch(tasksFailed(error.message))
        dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul crearii Taskului" } }));
    });
}


export const patchRsvtiTask = (task) => (dispatch) => {
    task.updateDate = new Date().toISOString();

    const bearer = 'Bearer ' + AuthC.getJwtToken();
    
    return fetch(awsConfig.api.invokeUrl + RestURI.TASKS + `/${task.id}`, {
        method: "PATCH",
        body: JSON.stringify(task),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
    .then(response => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error('Error ' + response.status + ': ' + response.statusText);
          error.response = response;
          throw error;
        }
      },
      error => {
        throw error;
      }
    )
    .then(response => response.json())
    .then(ddbTask => dispatch(updateTask(ddbTask)))
    .catch(error =>  {
        dispatch(tasksFailed(error.message))
        dispatch(addToBucket({ snackbar: { open: true, severity: "error", message: "Eroare in timpul actualizarii Taskului" } }));
    });
}

const tasksLoading = (loadCriteria) => ({
    type: ActionTypes.TASKS_LOADING,
    payload: loadCriteria
});
 
const tasksFailed = (errmess) => ({
    type: ActionTypes.TASKS_FAILED,
    payload: errmess
});

const addTasks = (tasks) => ({
    type: ActionTypes.ADD_TASKS,
    payload: tasks
});

const addTask = (task) => ({
    type: ActionTypes.ADD_TASK,
    payload: task
});

const updateTask = (task) => ({
    type: ActionTypes.UPDATE_TASK,
    payload: task
});
